import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { CabinetType } from "../models/cabinet-type.model";

const BASE_URL = `${BACKEND_URI}/api/cabinetType`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class CabinetTypeService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<CabinetType[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<CabinetType[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<CabinetType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<CabinetType>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: CabinetType): Promise<CabinetType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<CabinetType>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: CabinetType): Promise<CabinetType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<CabinetType>(UPDATE_URL(id), data)
            );
        }
    }


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }      
    }